import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import React from 'react';
import { FaGripVertical } from 'react-icons/fa';
import { ChakraV3 } from '..';

interface Props extends Omit<ChakraV3.IconButtonProps, 'aria-label'> {
  listeners: SyntheticListenerMap | undefined;
  attributes: DraggableAttributes;
}

export const DragHandle = (props: Props) => {
  const { listeners, attributes, ...rest } = props;

  return (
    <ChakraV3.IconButton
      variant='ghost'
      aria-label='Drag handle'
      color='gray.400'
      cursor='grab'
      _hover={{
        bg: 'gray.100',
      }}
      minW={7}
      onClick={() => undefined}
      {...listeners}
      {...attributes}
      {...rest}
    >
      <ChakraV3.Icon height='10px'>
        <FaGripVertical />
      </ChakraV3.Icon>
    </ChakraV3.IconButton>
  );
};
